











































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Recorder extends Vue {
  @Prop({ default: false }) private recording!: boolean;
}
